module.exports = __webpack_public_path__ + "static/media/Geoff Stevens Headshot.8e65ab9e.jpeg";